// src/components/Scoreboard.jsx
import React, { useState, useEffect } from 'react';
import './Scoreboard.css';

const Scoreboard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 1000);
    return () => clearInterval(interval);
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch('https://score.strangebox.org:3443/api/all');
      const result = await response.json();
      
      if (result.success) {
        setData(result.data);
        setError(null);
      } else {
        setError('數據獲取失敗');
      }
    } catch (err) {
      setError('連接錯誤');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const formatTime = (seconds) => {
    if (!seconds) return '00:00';
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const formatRadiation = (value) => {
    if (value === undefined || value === null) return '0.00';
    return Number(value).toFixed(2);
  };

  if (loading) {
    return <div className="loading">載入中...</div>;
  }

  return (
    <div className="scoreboard">
      <div className="header">
        <h3>《麥塊新春挖礦大賽2026:輻射危機》</h3>
      </div>

      <div className="player-section">
        <div className="row">
          <span className="label">名稱:</span>
          <span className={data?.player?.error ? 'error' : 'value'}>
            {data?.player?.playername || '---'}
          </span>
        </div>
        <div className="row">
          <span className="label">積分:</span>
          <span className="value">{data?.player?.point ?? 0}</span>
        </div>
        <div className="row">
          <span className="label">排名:</span>
          <span className="value">{data?.player?.rank ?? 0}</span>
        </div>
        <div className="row">
          <span className="label">輻射值:</span>
          <span className="value">{formatRadiation(data?.player?.radiation_stack) ?? 0}</span>
        </div>
        <div className="row">
          <span className="label">在線人數:</span>
          <span className="value">{data?.total_online_players ?? 0}</span>
        </div>
        <div className="row">
          <span className="label">剩餘時間:</span>
          <span className="value">{formatTime(data?.player?.current_server_time)}</span>
        </div>
      </div>

      {error && (
        <div className="error-container">
          <span className="error-text">{error}</span>
        </div>
      )}

    </div>
  );
};

export default Scoreboard;